export const storeInitialRowPositions = (
    rows: Element[],
    prevChildrenPositions: Map<string, DOMRect>,
    rowItemParts: Map<string, Element[]>
) => {
    rows.forEach(row => {
        // Store the old positions of the elements
        if ((row as HTMLDivElement).children.length == 2) {
            // The second child of a mailRow is the itemParts
            const itemPartChildren = Array.from(
                (row as HTMLDivElement).children[1].children[0].children
            );

            itemPartChildren.forEach(itemPartRow => {
                prevChildrenPositions.set(itemPartRow.id, itemPartRow.getBoundingClientRect());
            });

            rowItemParts.set(row.id, itemPartChildren);
        }
        prevChildrenPositions.set(row.id, row.getBoundingClientRect());
    });
};
